import { useEffect, useState } from "react";
import { QuestionUnit } from "../courses/question-unit";



export const CompetencyBox = ({ testQuestions, passAnswer }) => {

    //const letterOpttions = ['A', 'B', 'C', 'D'];
    const [answers, setAnswers] = useState({});
    const [submited] = useState(false);

    useEffect(() => {
        passAnswer(answers);
    }, [answers, passAnswer])


    return (
        <div className="comp-box">
            {testQuestions?.map((question, i) => {
                return (
                    <div className="comp-q-unit-container">
                        <QuestionUnit
                            questionData={question}
                            indx={i}
                            addAnswer={(k) => setAnswers((answ) => ({ ...answ, [i]: k }))}
                            key={i}
                            submited={submited}
                        />
                    </div>
                )
            })}
        </div>
    )
}